import { Component } from '@angular/core';

@Component({
  selector: 'app-ac-error',
  templateUrl: 'autocomplete-error.component.html',
  styleUrls: ['./autocomplete-error.component.scss'],
})
export class AutocompleteErrorComponent {}
